const state = {
  i18n: undefined,
};

const mutations = {
  setTranslations(state, i18n) {
    state.i18n = i18n;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
